import React from 'react';
import Lottie from 'react-lottie';

import { TransitionMotion } from 'react-motion'

import * as animationData from './assets/jumping-partners.json'

import { Container } from './styles'

const defaultOptions = {
  loop: true,
  autoplay: true, 
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice'
  }
};

interface LoadingProps {}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function Loading(props: LoadingProps) {
  return (
    <Container>
      <Lottie options={defaultOptions}
          height={400}
          width={400} />
    </Container>
  );
};

export default Loading;